module.exports = __webpack_public_path__ + "img/gem.90a6efee.svg";